import type { SettingSectionLayout } from '../settingLayout';

/** The "Invoice review, approval and sending" section: its group bands and their rows, in page order. */
export const INVOICE_REVIEW_SECTION: SettingSectionLayout = {
    anchor: 'invoice-review',
    groups: [],
};
